<template lang="pug">
div
	.alert.alert-warning
		|Aquí puedes definir el horario habitual de cada empleado, así como su jornada semanal
	table.table.table-condensed
		thead
			tr
				th Día
				th Hora entrada
				th Hora salida
				th(style="width:30px;").text-center
					button.btn.btn-sm.btn-primary(@click="nuevoHorario")
						span.fa.fa-plus
		tbody
			tr(
				v-for="(h, i) in usuario.horario"
				:key="h.HorarioID"
			)
				td
					select.form-control.form-control-sm(v-model="usuario.horario[i].DiaSemana")
						option(
							v-for="dia in dias" :key="dia" :value="dia"
						) {{dia}}
				td
					input.form-control.form-control-sm(type="time", v-model="usuario.horario[i].HoraEntrada")
				td
					input.form-control.form-control-sm(type="time", v-model="usuario.horario[i].HoraSalida")
				td(style="width:30px;").text-center
					button.btn.btn-sm.btn-danger(@click="quitar(h.HorarioID)")
						span.fa.fa-trash
	.text-right
		.input-group
			.input-group-prepend
				.input-group-text
					span.mr-2 Jornada semanal
					b {{ jornadaSemanal | hora }}
					span.ml-2 horas 
			.input-group-append
				button.btn.btn-primary(@click="guardarHorario()")
					span.fa.fa-save.mr-2
					|Guardar horario
</template>

<script>
import axios from 'axios'
export default {
	props: ['usuario'],
	data () {
		return {
			dias: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
			horario: []
		}
	},
	computed: {
		jornadaSemanal () {
			if (!this.usuario || !this.usuario.horario) {
				return 0
			}
			return this.usuario.horario.reduce((acum, horario) => {
				if (horario.HoraEntrada && horario.HoraSalida) {
					const entrada = this.$options.filters.segundos(horario.HoraEntrada)
					const salida = this.$options.filters.segundos(horario.HoraSalida)
					acum = acum + (salida - entrada)
				}

				return acum
			}, 0)
		}
	},
	methods: {
		nuevoHorario () {
			this.usuario.horario.push({
				HorarioID: new Date().getTime(),
				DiaSemana: 'Lunes',
				HoraEntrada: null,
				HoraSalida: null
			})
		},
		quitar (id) {
			this.usuario.horario = this.usuario.horario.filter(h => h.HorarioID !== id)
		},
		guardarHorario () {
			const form = {
				UsuarioID: this.usuario.ID,
				horario: this.usuario.horario
			}
			axios.post('gestion-jornada/php/api/setHorario.php', form)
				.then(res => {
					this.$store.commit('toast/success', {
						titulo: 'Guardar',
						mensaje: 'Se ha guardado el horario correctamente'
					})
				})
				.catch(e => {
					this.$error('Error', e.response.data.error)
				})
		}
	}
}
</script>

<style scoped>
.horario {
	display: flex;
	flex-direction: row;
	width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/modulos/gestion-usuarios/vue/editor/horario.vue